import { PurchaseLabelType } from "@redotech/merchant-sdk/rpc/schema/purchase-label";
import { Rate } from "@redotech/redo-fulfillment-carrier-common/shipment";
import { useTranslation } from "@redotech/redo-i18n";
import { MerchantAppReturn } from "@redotech/redo-return-core-common/return";
import { Team } from "@redotech/redo-team-common/team";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { getDatadogActionName } from "@redotech/redo-web/datadog-action-name";
import { memo, useMemo } from "react";
import { LabelRate } from "./label-rate";

export const CarrierSelect = memo(function CarrierSelect({
  labelRateInUse,
  onSelectLabel,
  rates,
  isPending,
  return_,
  labelType,
  originalLabelCost,
  team,
  disabled,
  placeholder,
  "data-dd-action-name": actionName,
}: {
  labelRateInUse: Rate | undefined;
  onSelectLabel: (rate: Rate) => void;
  rates: Rate[];
  isPending: boolean;
  return_: MerchantAppReturn;
  labelType: PurchaseLabelType;
  originalLabelCost: number;
  team: Team;
  disabled: boolean;
  placeholder: string;
  "data-dd-action-name"?: string;
}) {
  const { t } = useTranslation();
  const options = rates.map((carrier) => ({
    id: carrier.id,
    type: "custom" as const,
    value: carrier,
    custom: true,
    useWrapper: true,
    render: (
      <LabelRate
        labelRate={carrier}
        labelType={labelType}
        originalLabelCost={originalLabelCost}
        return_={return_}
        team={team}
      />
    ),
  }));

  const selectedItem = useMemo(() => {
    const found = options.find((option) => option.id === labelRateInUse?.id);
    if (!found || !labelRateInUse) {
      return undefined;
    }
    return {
      ...found,
      render: (
        <LabelRate
          isButtonDisplay
          labelRate={labelRateInUse}
          labelType={labelType}
          originalLabelCost={originalLabelCost}
          return_={return_}
          team={team}
        />
      ),
    };
  }, [options, labelRateInUse, labelType, originalLabelCost, return_, team]);

  return (
    <RedoSingleSelectDropdownInput
      data-dd-action-name={getDatadogActionName(actionName, "menu_toggle")}
      disabled={disabled}
      fullWidth
      itemsLoading={isPending}
      label={t("Carrier")}
      options={options.map((option) => ({
        ...option,
        "data-dd-action-name": getDatadogActionName(actionName, "select"),
      }))}
      optionSelected={({ item }) => onSelectLabel(item.value)}
      placeholder={placeholder}
      selectedItem={selectedItem}
      size="xs"
    />
  );
});
